import Vue from 'vue'
import VueRouter from 'vue-router'
import NewTab from '@/views/NewTab.vue'
import ListTab from '@/views/ListTab.vue'
import TestTab from '@/views/TestTab.vue'
import Login from '@/views/Login.vue'
import Edit from '@/views/Edit.vue'
import Show from '@/views/Show.vue'

Vue.use(VueRouter)

const routes  = [
    {
        path: '/',
        name: 'Új',
        component: NewTab
    },
    {
        path: '/list',
        name: 'Lista',
        component: ListTab
    },
    {
        path: '/edit/:id',
        name: 'Edit',
        component: Edit
    },
    {
        path: '/show/:id',
        name: 'Show',
        component: Show
    },
    {
        path: '/test',
        name: 'Teszt',
        component: TestTab
    },
    {
        path: '/login',
        name: 'Bejelentkezés',
        component: Login
    }
]

const router = new VueRouter ({
    mode: 'history',
    base: process.env.BASE_URL,
    linkExactActiveClass: "is-active",
    routes
})

export default router
